import type {
  NarrationAbsentReason,
  NarrationTimeline,
} from "./narrationTimeline";

// ---------------------------------------------------------------------------
// Operator-facing wording for the narration surfaces, kept out of the component
// files so every surface says the same thing (and so fast refresh keeps
// working — a module that exports both components and constants breaks it).
// ---------------------------------------------------------------------------

/** Why an Echo legitimately has no narration, phrased for a human. */
export const NARRATION_ABSENT_COPY: Record<NarrationAbsentReason, string> = {
  song_mode: "This Echo is cut to a song — it has no narrator.",
  no_narration: "This Echo's script contains no narration lines.",
};

/** How each rung of the narration tier ladder is labelled in the UI. */
export const NARRATION_TIER_LABEL: Record<NarrationTimeline["source"], string> =
  {
    manifest_narration: "narration · exact",
    stem_overlap_windows: "narration · good",
    voiceover_files: "narration · measured",
    planned_estimate: "narration · estimated",
  };
